import { render } from "./ShopModalItem.vue?vue&type=template&id=16aaad20"
import script from "./ShopModalItem.vue?vue&type=script&lang=js"
export * from "./ShopModalItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vixfs/PhpstormProjects/fitbase/frontend/web/vue-resources/personal-account/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__